import React from "react";
import styles from "./video.module.scss"

function Video({urlVideo}) {

    function getEmbedUrl(url) {
        // Google Drive: https://drive.google.com/file/d/{ID}/view...
        const driveMatch = url.match(/drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)/);
        if (driveMatch) {
            return `https://drive.google.com/file/d/${driveMatch[1]}/preview`;
        }

        // YouTube
        let ID;
        const parts = url.replace(/([><])/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
        if (parts[2] !== undefined) {
            ID = parts[2].split(/[^0-9a-z_-]/i)[0];
        } else {
            ID = parts;
        }
        return `https://www.youtube.com/embed/${ID}`;
    }


    return (
        <div className={styles.videoContainer}>
            <iframe
                title={'videoCompanyFrame'}
                className={styles.videoFrame}
                src={getEmbedUrl(urlVideo)}
                frameBorder="0"
                allow="autoplay"
            />
        </div>
    );
}

export default Video;
